var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"show-slots-btn",class:{ 'hide-with-opacity': _vm.isHidden },attrs:{"href":"#"}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('selectApptTimeStep.pickAnotherTimeCta'))+" ")]),_c('i',{staticClass:"el-icon-arrow-down"})])
}
var staticRenderFns = []

export { render, staticRenderFns }